/**
 * ============================================================
 *  3D Product Builder 配置文件
 *  客户以后只需要改这个文件，不需要动其他代码
 * ============================================================
 *
 *  修改指南：
 *  - model.parts  → 每个部件的 GLB 模型文件地址
 *  - shopify      → 产品变体 ID 和价格映射
 *  - options      → 选项标题、颜色、价格
 *  - accessories  → 配件名称、价格、变体 ID
 *
 *  如何查看 GLB 里的 mesh 名称：
 *  - 用 https://gltf-viewer.donmccurdy.com 打开你的 GLB
 *  - 在右侧面板可以看到所有 mesh 节点的名称
 * ============================================================
 */

window.ProductBuilderConfig = {
  // ---- 产品基本信息 ----
  productTitle: "Keppi Fitness",
  productName: "Keppi Power Rack SD800",
  basePrice: 0,
  currency: "$",

  // ---- 3D 模型（多文件分别加载） ----
  model: {
    // DRACOLoader 解码路径（你的 GLB 用了 Draco 压缩）
    dracoPath: "https://www.gstatic.com/draco/versioned/decoders/1.4.1/",
    // 场景缩放和位置
    scale: 1.0,
    position: { x: 0, y: 0, z: 0 },
    // 各部件模型文件
    // 每个 key 对应 options 里 color 选项的 partType
    parts: {
      main: [
        { url: "https://cdn.shopify.com/3d/models/c7b46752358ad2e0/_.glb", name: "Main Frame" }
      ],
      base: [
        { url: "https://cdn.shopify.com/3d/models/9f85cbbad89b4d9a/_.glb", name: "Base Support" }
      ],
      crossmember: [
        { url: "https://cdn.shopify.com/3d/models/e3e0ed09da227f91/_-31_.glb", name: "Crossmember 31\"", depth: "31" },
        { url: "https://cdn.shopify.com/3d/models/43d8c5dcbb197638/_-41_.glb", name: "Crossmember 41\"", depth: "41" },
        { url: "https://cdn.shopify.com/3d/models/e9e63c8c0d560d7c/_-16_.glb", name: "Crossmember 16\"", depth: "16" }
      ],
      upright: [
        { url: "https://cdn.shopify.com/3d/models/869342a14f8d8c4e/_.glb", name: "Upright" }
      ],
      height: [
        { url: "https://cdn.shopify.com/3d/models/c7b46752358ad2e0/_.glb", name: "93\"", height: "93" },
        { url: "https://cdn.shopify.com/3d/models/c7b46752358ad2e0/_.glb", name: "80\"", height: "80" }
      ],
      logo: [
        { url: "https://cdn.shopify.com/3d/models/2a7ba1aa7c694990/logo_.glb", name: "Logo Plate" }
      ],
      jhook: [
        { url: "https://cdn.shopify.com/3d/models/61b93e0a280a6ee8/J_.glb", name: "J-Hook" }
      ],
      safety: [
        { url: "https://cdn.shopify.com/3d/models/9f501665beb8e8d7/_.glb", name: "Safety Bar" }
      ],
      pullup: [
        { url: "https://cdn.shopify.com/3d/models/29d22f1c6f61b2f2/_.glb", name: "Pull-Up Bar" }
      ],
      flybird: [
        { url: "https://cdn.shopify.com/3d/models/12e5e0f2d73f23ab/_.glb", name: "Flybird Back" }
      ]
    }
  },

  // ---- 视角预设 ----
  cameraViews: {
    front:  { position: { x: 0,   y: 1.5, z: 5   }, target: { x: 0, y: 1.5, z: 0 } },
    side:   { position: { x: 5,   y: 1.5, z: 0   }, target: { x: 0, y: 1.5, z: 0 } },
    top:    { position: { x: 0,   y: 6,   z: 0.01 }, target: { x: 0, y: 1.5, z: 0 } },
    detail: { position: { x: 2,   y: 2,   z: 3   }, target: { x: 0, y: 1.5, z: 0 } }
  },

  // ---- 颜色名称映射（用于购物车属性显示） ----
  colorNameMap: {
    "#2c3e50": "Dark Black",
    "#ff4500": "Racing Red",
    "#3498db": "Deep Blue",
    "#e74c3c": "Flame Red",
    "#2ecc71": "Emerald Green",
    "#9b59b6": "Violet",
    "#f1c40f": "Golden Yellow",
    "#ffd700": "Gold",
    "#c0c0c0": "Silver"
  },

  // ---- 默认颜色 ----
  defaultColors: {
    main: "#2c3e50",
    crossmember: "#2c3e50",
    upright: "#2c3e50",
    logo: "#ffd700",
    jhook: "#ff4500",
    safety: "#ff4500",
    base: "#2c3e50",
    pullup: "#2c3e50"
  },

  // ---- Shopify 变体 ID 映射 ----
  shopify: {
    // 配件组合 → 变体 ID
    variantMap: {
      "Pull Up Bar": 50256522313921,
      "Protective Bar": 50256522346689,
      "Weight Stack": 50256522379457,
      "Cover Panel": 50256522412225,
      "Pull Up Bar+Protective Bar": 50256522444993,
      "Pull Up Bar+Weight Stack": 50256522477761,
      "Pull Up Bar+Cover Panel": 50256522510529,
      "Protective Bar+Weight Stack": 50256522543297,
      "Protective Bar+Cover Panel": 50256522576065,
      "Weight Stack+Cover Panel": 50256522608833,
      "Pull Up Bar+Protective Bar+Weight Stack": 50256522641601,
      "Pull Up Bar+Protective Bar+Cover Panel": 50256522674369,
      "Pull Up Bar+Weight Stack+Cover Panel": 50256522707137,
      "Protective Bar+Weight Stack+Cover Panel": 50256522739905,
      "All accessores": 50256522772673,
      "Smith Attachment YES": 50340289413313,
      "Smith Attachment NO": 50340289446081,
      "Logo Plate STANDARD": 50340299800769,
      "Logo Plate STAINLESS": 50340299833537,
      "Logo Plate COMPACT": 0,
      "Cable System YES": 50340302717121,
      "Cable System NO": 50340302749889
    },
    // 配件排序（用于生成 variantKey）
    partOrder: ["Pull Up Bar", "Protective Bar", "Weight Stack", "Cover Panel"],
    // 额外选项价格
    extraPrices: {
      "Smith Attachment YES": 80,
      "Smith Attachment NO": 30,
      "Logo Plate STAINLESS": 15,
      "Cable System YES": 30
    }
  },

  // ---- 选项配置 ----
  // type 类型说明：
  //   "color"     → 颜色选择器，点击后改变对应 partType 所有模型颜色
  //   "button"    → 按钮选择器，用于尺寸/规格切换
  //   "accessory" → 配件选择器，带数量加减
  options: [
    // ========== 颜色选项 ==========
    {
      id: "main_color",
      title: "MAIN COLOR",
      type: "color",
      partType: "main",
      values: [
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 },
        { label: "Emerald Green", value: "emerald_green",color: "#2ecc71", price: 0 },
        { label: "Violet",        value: "violet",       color: "#9b59b6", price: 0 },
        { label: "Golden Yellow", value: "golden_yellow",color: "#f1c40f", price: 0 }
      ]
    },
    {
      id: "crossmember_color",
      title: "CROSSMEMBER COLOR",
      type: "color",
      partType: "crossmember",
      values: [
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 },
        { label: "Emerald Green", value: "emerald_green",color: "#2ecc71", price: 0 },
        { label: "Violet",        value: "violet",       color: "#9b59b6", price: 0 },
        { label: "Golden Yellow", value: "golden_yellow",color: "#f1c40f", price: 0 }
      ]
    },
    {
      id: "upright_color",
      title: "UPRIGHT COLOR",
      type: "color",
      partType: "upright",
      values: [
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 },
        { label: "Violet",        value: "violet",       color: "#9b59b6", price: 0 }
      ]
    },
    {
      id: "logo_color",
      title: "LOGO PLATE COLOR",
      type: "color",
      partType: "logo",
      values: [
        { label: "Gold",          value: "gold",         color: "#ffd700", price: 0 },
        { label: "Silver",        value: "silver",       color: "#c0c0c0", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 }
      ]
    },
    {
      id: "jhook_color",
      title: "J-HOOK COLOR",
      type: "color",
      partType: "jhook",
      values: [
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 }
      ]
    },
    {
      id: "safety_color",
      title: "SAFETY BAR COLOR",
      type: "color",
      partType: "safety",
      values: [
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 }
      ]
    },
    {
      id: "base_color",
      title: "BASE SUPPORT COLOR",
      type: "color",
      partType: "base",
      values: [
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 }
      ]
    },
    {
      id: "pullup_color",
      title: "PULL-UP BAR COLOR",
      type: "color",
      partType: "pullup",
      values: [
        { label: "Dark Black",    value: "dark_black",   color: "#2c3e50", price: 0 },
        { label: "Racing Red",    value: "racing_red",   color: "#ff4500", price: 0 },
        { label: "Deep Blue",     value: "deep_blue",    color: "#3498db", price: 0 },
        { label: "Flame Red",     value: "flame_red",    color: "#e74c3c", price: 0 }
      ]
    },

    // ========== 尺寸选项 ==========
    {
      id: "rack_height",
      title: "RACK HEIGHT",
      type: "button",
      values: [
        { label: "93\"", value: "93", price: 0 },
        { label: "80\"", value: "80", price: 0 }
      ]
    },
    {
      id: "rack_depth",
      title: "RACK DEPTH",
      type: "button",
      values: [
        { label: "41\"", value: "41", price: 0 },
        { label: "31\"", value: "31", price: 0 },
        { label: "16\"", value: "16", price: 0 }
      ]
    },

    // ========== 规格选项 ==========
    {
      id: "logo_plate",
      title: "LOGO PLATE",
      type: "button",
      values: [
        { label: "STANDARD",  value: "standard",  price: 0 },
        { label: "STAINLESS", value: "stainless", price: 15 },
        { label: "COMPACT",   value: "compact",   price: 0 }
      ]
    },
    {
      id: "cable_system",
      title: "CABLE SYSTEM",
      type: "button",
      values: [
        { label: "YES", value: "yes", price: 30 },
        { label: "NO",  value: "no",  price: 0 }
      ]
    },
    {
      id: "additional_post",
      title: "ADDITIONAL POST",
      type: "button",
      values: [
        { label: "YES", value: "yes", price: 0 },
        { label: "NO",  value: "no",  price: 0 }
      ]
    },
    {
      id: "j_cups",
      title: "J-CUPS",
      type: "button",
      values: [
        { label: "STANDARD", value: "standard", price: 0 }
      ]
    },
    {
      id: "pullup_type",
      title: "PULL-UP BAR TYPE",
      type: "button",
      values: [
        { label: "STANDARD",   value: "standard",  price: 0 },
        { label: "GLOBE GRIP", value: "multigrip", price: 0 }
      ]
    },
    {
      id: "safeties",
      title: "SAFETIES",
      type: "button",
      values: [
        { label: "SAFETY BAR",   value: "bar",   price: 0 },
        { label: "SAFETY STRAPS",value: "straps", price: 0 }
      ]
    },
    {
      id: "attachments",
      title: "ATTACHMENTS",
      type: "button",
      values: [
        { label: "LANDMINE", value: "landmine", price: 0 },
        { label: "POST",     value: "post",     price: 0 }
      ]
    },
    {
      id: "smith_attachment",
      title: "SMITH ATTACHMENT",
      type: "button",
      values: [
        { label: "YES", value: "yes", price: 80 },
        { label: "NO",  value: "no",  price: 30 }
      ]
    },

    // ========== 配件 ==========
    {
      id: "accessories",
      title: "OPTIONAL ACCESSORIES",
      type: "accessory",
      values: [
        {
          label: "Pull Up Bar",
          value: "pull_up_bar",
          price: 149,
          defaultQty: 0,
          maxQty: 10,
          icon: "https://cdn.shopify.com/s/files/1/0561/6166/5217/files/17_ceb32495-4c8f-4603-bd6e-a6dd22e35b0d.png?v=1781231293"
        },
        {
          label: "Protective Bar",
          value: "protective_bar",
          price: 79,
          defaultQty: 0,
          maxQty: 10,
          icon: "https://cdn.shopify.com/s/files/1/0561/6166/5217/files/17_ceb32495-4c8f-4603-bd6e-a6dd22e35b0d.png?v=1781231293"
        },
        {
          label: "Weight Stack",
          value: "weight_stack",
          price: 399,
          defaultQty: 0,
          maxQty: 10,
          icon: "https://cdn.shopify.com/s/files/1/0561/6166/5217/files/17_ceb32495-4c8f-4603-bd6e-a6dd22e35b0d.png?v=1781231293"
        },
        {
          label: "Cover Panel",
          value: "cover_panel",
          price: 49,
          defaultQty: 0,
          maxQty: 10,
          icon: "https://cdn.shopify.com/s/files/1/0561/6166/5217/files/17_ceb32495-4c8f-4603-bd6e-a6dd22e35b0d.png?v=1781231293"
        }
      ]
    }
  ]
};

/* ============================================================
 *  合并主题编辑器的可视化设置
 *  如果 Shopify 主题编辑器传入了设置，则覆盖这里的默认值
 *  这样客户可以直接在主题编辑器右侧面板修改基本设置
 * ============================================================ */
(function mergeSectionSettings() {
  var s = window.ProductBuilderSectionSettings;
  if (!s) return; // 本地预览时没有 Shopify 设置，跳过

  var cfg = window.ProductBuilderConfig;

  function parseJsonSetting(value, label) {
    if (value === undefined || value === null) return null;
    if (typeof value !== "string") return value;

    var text = value.trim();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (error) {
      console.warn("3D Product Builder：" + label + " 不是合法 JSON，已继续使用默认配置。", error);
      return null;
    }
  }

  // 产品基本信息
  if (s.productTitle) cfg.productTitle = s.productTitle;
  if (s.productName) cfg.productName = s.productName;
  if (s.basePrice !== undefined && s.basePrice !== null) cfg.basePrice = Number(s.basePrice) || 0;
  if (s.currency) cfg.currency = s.currency;

  // 按钮和提示文字
  if (s.add_to_cart_text) cfg.addToCartText = s.add_to_cart_text;
  if (s.checkout_text) cfg.checkoutText = s.checkout_text;
  if (s.cart_success_text) cfg.cartSuccessText = s.cart_success_text;
  if (s.continue_shopping_text) cfg.continueShoppingText = s.continue_shopping_text;
  if (s.total_label) cfg.totalLabel = s.total_label;

  // 3D 模型设置
  if (s.dracoPath) cfg.model.dracoPath = s.dracoPath;

  // 主题编辑器高级 JSON 配置
  var modelParts = parseJsonSetting(s.modelPartsJson, "全部模型 GLB 配置");
  if (modelParts && typeof modelParts === "object" && !Array.isArray(modelParts)) {
    cfg.model.parts = modelParts;
  }

  var defaultColors = parseJsonSetting(s.defaultColorsJson, "默认颜色配置");
  if (defaultColors && typeof defaultColors === "object" && !Array.isArray(defaultColors)) {
    cfg.defaultColors = defaultColors;
  }

  var colorNameMap = parseJsonSetting(s.colorNameMapJson, "颜色名称映射");
  if (colorNameMap && typeof colorNameMap === "object" && !Array.isArray(colorNameMap)) {
    cfg.colorNameMap = colorNameMap;
  }

  var options = parseJsonSetting(s.optionsJson, "右侧全部选择器配置");
  if (Array.isArray(options)) {
    cfg.options = options;
  }

  var variantMap = parseJsonSetting(s.variantMapJson, "Shopify 变体 ID 映射");
  if (variantMap && typeof variantMap === "object" && !Array.isArray(variantMap)) {
    cfg.shopify.variantMap = variantMap;
  }

  var partOrder = parseJsonSetting(s.partOrderJson, "配件排序");
  if (Array.isArray(partOrder)) {
    cfg.shopify.partOrder = partOrder;
  }

  var cameraViews = parseJsonSetting(s.cameraViewsJson, "相机视角配置");
  if (cameraViews && typeof cameraViews === "object" && !Array.isArray(cameraViews)) {
    cfg.cameraViews = cameraViews;
  }

  // 默认视角
  if (s.defaultView && cfg.cameraViews && cfg.cameraViews[s.defaultView]) {
    cfg._defaultView = s.defaultView;
  } else {
    cfg._defaultView = "front";
  }
})();
